import {
  DataTable,
  DataTableColumn,
  DataTableSortStatus,
} from "mantine-datatable";

import "./table.scss";

interface UiTableProps<T = any> {
  loading?: boolean;
  columns: DataTableColumn<T>[];
  rows: T[];
  striped?: boolean;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
  sortStatus?: DataTableSortStatus<T>;
  onSortStatusChange?: (status: DataTableSortStatus<T>) => void;
  page?: number;
  pageSize?: number;
  totalElements?: number;
  totalPages?: number;
  pagination?: {
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
  };
}

export function UiTable<T>({
  columns,
  rows,
  loading,
  striped = false,
  onPageChange,
  onPageSizeChange,
  sortStatus,
  onSortStatusChange,
  page = 0,
  pageSize = 10,
  totalElements = 0,
  totalPages = 0,
}: UiTableProps<T>) {
  return (
    <>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <DataTable
          className="modern-datatable"
          records={rows}
          columns={columns}
          highlightOnHover
          striped={striped}
          withTableBorder={false}
          totalRecords={totalElements}
          recordsPerPage={pageSize}
          page={page}
          onPageChange={(p) => onPageChange?.(p)}
          recordsPerPageOptions={[5, 10, 20, 50]}
          onRecordsPerPageChange={(v: number) => onPageSizeChange?.(v)}
          sortStatus={sortStatus || ({} as DataTableSortStatus<T>)}
          onSortStatusChange={onSortStatusChange}
          fetching={loading}
          borderRadius={0}
          shadow="none"
          styles={{
            header: {
              backgroundColor: "#f8fafc",
              borderBottom: "1px solid #e2e8f0",
              fontSize: "12px",
              fontWeight: 600,
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            },
            table: {
              backgroundColor: "white",
              border: "none",
            },
            pagination: {
              backgroundColor: "#f8fafc",
              borderTop: "1px solid #e2e8f0",
              padding: "16px 24px",
            },
          }}
          rowClassName={(record, index) =>
            `${
              striped && index % 2 === 1 ? "bg-gray-50/50" : ""
            } hover:bg-gray-50 transition-colors duration-150`
          }
          paginationText={({ from, to, totalRecords }) => (
            <span className="text-sm text-gray-600">
              Affichage de <span className="font-medium">{from}</span> à{" "}
              <span className="font-medium">{to}</span> sur{" "}
              <span className="font-medium">{totalRecords}</span> éléments
            </span>
          )}
          noRecordsText="Aucune donnée trouvée"
          loadingText="Chargement..."
          // emptyState={
          //   <div className="flex flex-col items-center justify-center py-16 text-center min-h-[200px]">
          //     <SearchIcon className="w-12 h-12 text-gray-300 mb-4" />
          //     <h3 className="text-lg font-medium text-gray-900 mb-2">
          //       Aucune donnée trouvée
          //     </h3>
          //     <p className="text-sm text-gray-500 max-w-sm">
          //       Aucun élément ne correspond à vos critères de recherche. Essayez
          //       de modifier vos filtres.
          //     </p>
          //   </div>
          // }
        />
      </div>
    </>
  );
}
